"use client";

import { useOptimistic, useRef, useTransition } from "react";
import { useRouter } from "next/navigation";

export function PlazaPopularSearch({ selected, query, options, className, basePath = "/plaza" }: {
  basePath?: string;
  selected?: string[];
  query?: string;
  options: (string | { query: string; href: string })[];
  className: string;
}) {
  // Accept the previous server payload during Fast Refresh or an in-flight navigation.
  const choices = options.map(option => typeof option === "string" ? option : option.query);
  const active = selected ?? (query && choices.includes(query) ? [query] : []);
  const router = useRouter();
  const [selection, select] = useOptimistic(active);
  const [pending, startTransition] = useTransition();
  const pendingSelection = useRef(active);

  return (
    <div className={className} aria-busy={pending}>
      <span>热门搜索</span>
      {choices.map(query => (
        <button
          key={query}
          type="button"
          aria-pressed={selection.includes(query)}
          onClick={() => {
            const current = pending ? pendingSelection.current : active;
            const next = current.includes(query) ? current.filter(value => value !== query) : [...current, query];
            pendingSelection.current = next;
            const params = new URLSearchParams(window.location.search);
            if (choices.includes(params.get("q") ?? "")) params.delete("q");
            params.delete("hot");
            params.delete("page");
            next.forEach(value => params.append("hot", value));
            startTransition(() => {
              select(next);
              router.push(params.size ? `${basePath}?${params}` : basePath, { scroll: false });
            });
          }}
        >
          {query}
        </button>
      ))}
    </div>
  );
}
